import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-videoContent",
  "use": "icon-videoContent-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-videoContent\"><path d=\"M512 0a512 512 0 1 1 0 1024A512 512 0 0 1 512 0zM441.571556 312.206222a56.888889 56.888889 0 0 0-56.888889 56.888889v286.549333a56.888889 56.888889 0 0 0 86.755555 48.355556l232.789334-143.473778a56.888889 56.888889 0 0 0-0.113778-96.881778L471.324444 320.625778a56.888889 56.888889 0 0 0-29.752888-8.419556z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/videoContent.svg
// module id = Mwdt
// module chunks = 78